import { render, staticRenderFns } from "./TableNewCampSms.vue?vue&type=template&id=18967494&scoped=true&"
import script from "./TableNewCampSms.vue?vue&type=script&lang=js&"
export * from "./TableNewCampSms.vue?vue&type=script&lang=js&"
import style0 from "./TableNewCampSms.vue?vue&type=style&index=0&id=18967494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18967494",
  null
  
)

export default component.exports